<script setup lang="ts">
import AppSidebar from '@/components/layout/AppSidebar.vue'
import AppTopbar from '@/components/layout/AppTopbar.vue'
import FindingsSubNav from '@/components/sub-nav/FindingsSubNav.vue'
import TargetsSubNav from '@/components/sub-nav/TargetsSubNav.vue'
import InventorySubNav from '@/components/sub-nav/InventorySubNav.vue'
import MonitorSubNav from '@/components/sub-nav/MonitorSubNav.vue'
import ReportsSubNav from '@/components/sub-nav/ReportsSubNav.vue'
import SettingsSubNav from '@/components/sub-nav/SettingsSubNav.vue'
import AppModals from '@/components/modals/AppModals.vue'
</script>

<template>
  <div class="app">
    <AppSidebar />
    <div class="main">
      <AppTopbar />
      <div class="content">
        <!-- Sub-navs: each one is only displayed via CSS body[data-page=...] selector -->
        <FindingsSubNav />
        <TargetsSubNav />
        <InventorySubNav />
        <MonitorSubNav />
        <ReportsSubNav />
        <SettingsSubNav />

        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </div>
    <AppModals />
  </div>
</template>
